import { yupResolver } from "@hookform/resolvers/yup";
import axios from "axios";
import Button from "components/Button";
import Loading from "components/Loading";
import Modal from "components/Modal";
import Title from "components/Title";
import CardLayout from "components/form/CardLayout";
import FormLayout from "components/form/FormLayout";
import TwoSideLayout from "components/form/TwoSideLayout";
import GalleryInput from "components/gallery/GalleryInput";
import GalleryModal from "components/gallery/GalleryModal";
import SelectInputAsync from "components/inputs/SlectInputAsync";
import TextInput from "components/inputs/TextInput";
import apiEndpoints from "configs/apiEndPoints";
import { FC, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import toastFunc from "utils/toast";
import { useMutationCustom, useQueryCustom } from "utils/useQueryCUstom";
import { CONFIGS } from "../configs";
import { fieldNames, validation } from "./validation";

interface FormValues {
  name: string;
  email: string;
  password: string;
  confirm_password?: string;
}

const Add: FC = () => {
  let { id } = useParams();
  const navigate = useNavigate();
  const URL_ID = id ? id : "";
  const [editInitialLoading, setEditInitialLoading] = useState(id ? true : false);
  const { t } = useTranslation();

  const updateOrCreate = URL_ID
    ? (params: any) => axios.put(apiEndpoints[CONFIGS.apiName].base + "/" + URL_ID, params)
    : (params: any) => axios.post(apiEndpoints[CONFIGS.apiName].base, params);

  const methods = useForm<FormValues>({
    resolver: yupResolver(validation(URL_ID, t)),
  });

  // --------------------------------------------------- data by id query
  const onSuccessDataById = ({ data }: any) => {
    let params = { ...data?.data };
    methods.reset({
      ...params,
    });
    setEditInitialLoading(false);
  };
  const { data: dataById } = useQueryCustom({
    name: `${CONFIGS.title}_getById`,
    url: () => axios.get(apiEndpoints[CONFIGS.apiName].base + "/" + URL_ID),
    onSuccess: onSuccessDataById,
    enabled: !!URL_ID,
  });
  // --------------------------------------------------- Create or update mutation (base on URL_ID)
  const { isLoading, mutate: submitData } = useMutationCustom({
    url: updateOrCreate,
    invalidQuery: `${CONFIGS.title}_get`,
    onSuccess: () => {
      toastFunc.success({ title: "Success" });
      navigate(CONFIGS.routes.base);
    },
  });

  // -------------------------------------------- onSubmit
  const onSubmit = (data: FormValues) => {
    const requestData = {
      name: data.name,
      password: data.password || undefined,
      email: data.email,
    };
    submitData(requestData);
  };
  return (
    <div>
      {editInitialLoading && (
        <Modal isOpen={true} title={t("loadingData")}>
          <div className="flex justify-center items-center">
            <Loading size="w-8 h-8" />
          </div>
        </Modal>
      )}
      <Title
        hasBtn
        btnTitle={t("backTitle", { changeablePart: t(CONFIGS.title) })}
        title={URL_ID ? t("editTitle", { changeablePart: t(CONFIGS.title) }) : t("addNew", { changeablePart: t(CONFIGS.title) })}
        url={CONFIGS.routes.base + CONFIGS.routes.list}
      />

      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)} className="space-y-4">
          <FormLayout
            main={
              <>
                <CardLayout>
                  <>
                    <TextInput
                      isRequired
                      name={fieldNames.name}
                      placeholder={t("enterYourHere", { changeablePart: t(fieldNames.name) })}
                      label={fieldNames.name}
                      size="full"
                    />
                    <TextInput
                      isRequired
                      name={fieldNames.email}
                      placeholder={t("enterYourHere", { changeablePart: t(fieldNames.email) })}
                      label={fieldNames.email}
                      size="full"
                    />
                    <TextInput
                      isRequired
                      name={fieldNames.password}
                      placeholder={t("enterYourHere", { changeablePart: t(fieldNames.password) })}
                      type="password"
                      label={fieldNames.password}
                      size="full"
                    />
                    <TextInput
                      isRequired
                      name={fieldNames.confirm_password}
                      placeholder={t("enterYourHere", { changeablePart: t(fieldNames.confirm_password) })}
                      type="password"
                      label={fieldNames.confirm_password}
                      size="full"
                    />
                    {/* <SelectInputAsync name="test selection" apiName="servingUnit" label="test" isRequired /> */}
                  </>
                </CardLayout>
              </>
            }
            side={
              <CardLayout head={{ title: "action" }} className="sticky top-4">
                <Button type="submit" variant="success" isFullSize loading={isLoading}>
                  {t("submit")}
                </Button>
              </CardLayout>
            }
          />
        </form>
      </FormProvider>
    </div>
  );
};

export default Add;
